import React, { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import injectStyles from 'react-jss'

import { Col } from 'react-bootstrap'
import CampaignCard from 'Components/Campaigns/CampaignCard'
import { ClientViewCampaignsWrapper } from 'Components/Clients/ClientView/ClientViewCampaignsWrapper'
import { FilterButton } from 'Components/Filter/FilterButton'
import { SectionTitle } from 'Components/Section/SectionTitle/index'
import { SectionWrapper } from 'Components/Section/SectionWrapper/index'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { PATHS } from 'Config/Routing/paths'
import {
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
} from '../../../../shared/constants'
import { getCampaigns } from '../gql'
import { styles } from './styles'
import { authorization } from '../../../../Module/Auth/Auth'
import { shouldFetchActiveDates } from '../utils'

const CampaignsBlock = ({ classes, client }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const [campaigns, setCampaigns] = useState([])
  const [campaignsStatus, setCampaignsStatus] = useState(
    STATUS_CAMPAIGN_ENUM_ACTIVE,
  )
  const clientId = match.params.id

  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getCampaigns,
    defaultFetchArgs: { clientIds: clientId, statuses: campaignsStatus },
    mapResponse: data =>
      data.campaigns.edges.map(({ node }) => {
        let campaignTimeRange = null
        if (shouldFetchActiveDates(campaignsStatus)) {
          const formatDate = date => new Date(date).toLocaleDateString()
          const startDate = formatDate(node.activeDates.start)
          const endDate = formatDate(node.activeDates.end)
          campaignTimeRange =
            startDate === endDate ? null : `${startDate} - ${endDate}`
        }
        return {
          id: node.id,
          name: node.name,
          type: node.type,
          cityCount: node.cityPlans.nodes.length,
          status: node.status,
          campaignTimeRange,
        }
      }),
  })

  const noCampaignsText = campaignsStatus
    ? `No Campaigns with ${campaignsStatus} status`
    : 'This client has no campaigns'

  useEffect(() => {
    if (isLoaded) {
      setCampaigns(data)
    }
  }, [isLoaded])

  useEffect(() => {
    refetch({ clientIds: clientId, statuses: campaignsStatus })
  }, [campaignsStatus])

  const filterButtons = [
    {
      className:
        campaignsStatus === STATUS_CAMPAIGN_ENUM_ACTIVE ? 'active' : '',
      onClick: () => {
        setCampaignsStatus(STATUS_CAMPAIGN_ENUM_ACTIVE)
      },
      text: 'Active',
    },

    {
      className:
        campaignsStatus === STATUS_CAMPAIGN_ENUM_ARCHIVE ? 'active' : '',
      onClick: () => {
        setCampaignsStatus(STATUS_CAMPAIGN_ENUM_ARCHIVE)
      },
      text: 'Archived',
    },

    {
      className: campaignsStatus === null ? 'active' : '',
      onClick: () => {
        setCampaignsStatus(null)
      },
      text: 'All',
    },
  ]

  return (
    <SectionWrapper className="section-wrapper second">
      <SectionTitle className="section-title">Campaigns</SectionTitle>
      {filterButtons.map(button => (
        <FilterButton
          key={button.text}
          className={button.className}
          onClick={button.onClick}
        >
          {button.text}
        </FilterButton>
      ))}
      <ClientViewCampaignsWrapper>
        {isLoaded ? (
          campaigns.length > 0 ? (
            campaigns.map((campaign, index) => (
              <Col key={index} xs={4} className={classes.wrapperCard}>
                <CampaignCard
                  className="campaign-card"
                  title={campaign.name}
                  subTitle={client.name}
                  footer={campaign.type}
                  description={
                    <div>
                      Number of cities{' '}
                      <span className="number">{campaign.cityCount}</span>
                    </div>
                  }
                  img={client.logo}
                  status={campaign.status}
                  campaignTimeRange={campaign.campaignTimeRange}
                  onClick={() => {
                    history.push(
                      `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
                        campaign.id
                      }/city-plans`,
                    )
                  }}
                  viewPath={`${PATHS.main.dashboard}${
                    PATHS.dashboard.campaigns
                  }/${campaign.id}/city-plans`}
                  editPath={
                    authorization.isClient()
                      ? ''
                      : `${PATHS.main.dashboard}${PATHS.dashboard.campaigns}/${
                          campaign.id
                        }/edit`
                  }
                />
              </Col>
            ))
          ) : (
            <div className={classes.textCenter}>{noCampaignsText}</div>
          )
        ) : (
          <LoadingIndicator />
        )}
      </ClientViewCampaignsWrapper>
    </SectionWrapper>
  )
}

export default injectStyles(styles)(CampaignsBlock)



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/CampaignsBlock/index.js